export const METEOROLOGY_PLAYER_WIDTH = 350

// Distância do controle até a borda inferior da tela.
export const METEOROLOGY_CONTROL_BOTTOM = 20

// Distância usada quando o player encosta no painel da esquerda e não cabe na área livre: mais baixo,
// ele passa por baixo do painel de ferramenta da Toolbar.
export const METEOROLOGY_CONTROL_LOWERED_BOTTOM = 8

// Folga entre o player encostado e o painel da esquerda.
export const METEOROLOGY_PLAYER_PANEL_GAP = 10
